import CentraRichText from "@/app/(site)/_components/Page/Product/ProductDetail/ProductDescriptionText/CentraRichText"
import { clsx } from "@/src/utils/clsx"

interface ProductDescriptionTextProps {
    content: string
    className?: string
}

export default function ProductDescriptionText({
    content,
    className
}: ProductDescriptionTextProps) {
    if (!content) return null

    const baseClasses = clsx(
        "text-col-text-secondary Trade_Gothic_Text_16_150_0_300",
        "[&_p:last-child]:mb-0 [&_p]:mb-16",
        className
    )
    return (
        <CentraRichText content={content} className={baseClasses} baseHeadingLevel="h3" />
    )
}
